import StandardSelector from './StandardSelector'

const GenericKVSelector = (props, on_change_event, expression_type, input_kv) => {
    return (
        StandardSelector(props, on_change_event, input_kv, expression_type, "Select One")
    )
}

export default GenericKVSelector